class StepCarousel extends HTMLElement {
  constructor() {
        super();
        this.swiperDom = this.querySelector(".step-carousel-swiper")
        this.mySwiper = new Swiper(this.swiperDom, {
            pagination: {
                el: this.querySelector('.swiper-pagination'),
                type: "progressbar",
            },
            navigation: {
                nextEl: this.querySelector('.swiper-button-next'),
                prevEl: this.querySelector('.swiper-button-prev'),
            },
            breakpoints:{
                0:{
                    slidesPerView:1.2,
                    spaceBetween:10,
                },
                768:{
                    slidesPerView:3.1,
                    spaceBetween:20,
                },
            }
        })
    }
}

reg("step-carousel", StepCarousel);